import { isProd } from "@/Env";

// Google Ads 전환 추적
export const GA_ADS_ID = "AW-10987830370";
export const GA_ADS_SEND_TO = `${GA_ADS_ID}/I2oACPKS3oAYEOL4s_co`;

// GA4 Analytics (Firebase Analytics에서 마이그레이션)
export const GA4_ID = isProd ? "G-DWKTELHEFV" : "G-511W8FGLWJ";
